import React, { useRef } from "react";
import styled from "styled-components";
import ToolbarHeader from "./components/ToolbarHeader";
import Header from "./components/Header";
import About from "./components/About";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Skills from "./components/Skills";

function App() {
  const skillsRef = useRef(null);
  const projectsRef = useRef(null);
  const aboutRef = useRef(null);
  const contactRef = useRef(null);

  const scrollToRef = (ref: any) => {
    if (ref) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Container>
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-539WPDKF"
          height="0"
          width="0"
          title="Google Tag Manager"
          style={{ display: "none", visibility: "hidden" }}
        ></iframe>
      </noscript>
      <Background>
        <ToolbarHeader />
        <Content>
          <Header
            skillsRef={skillsRef}
            projectsRef={projectsRef}
            aboutRef={aboutRef}
            contactRef={contactRef}
            scrollToRef={scrollToRef}
          />
          <Skills ref={skillsRef} />
          <Projects ref={projectsRef} />
          <About ref={aboutRef} />
          <Contact ref={contactRef} />
        </Content>
      </Background>
      <Footer>Designed by Kamil &copy; 2024</Footer>
    </Container>
  );
}

export default App;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 1200px;
  min-width: 310px;
  width: 100%;
  overflow: hidden;
  overflow: hidden;
  justify-content: center;

  @media (max-width: 460px) {
    font-size: 0.9rem;
  }
`;

const Background = styled.section`
  max-width: 1200px;
  width: 100%;
  max-height: 85vh;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  padding-bottom: 20px;
  overflow-y: auto;
  overflow-x: hidden;

  & p {
    color: white;
    width: 100%;
  }
`;

const Content = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
  padding-right: 2px;
  max-height: 100%;
`;

const Footer = styled.div`
  margin: auto;
  color: black;
  font-size: 1.2rem;
  font-weight: bolder;
`;
